import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import BlockAds from '../components/BlockAds';
import FasterLoading from '../components/FasterLoading';
import Privacy from '../components/Privacy';
import Pricing from '../components/Pricing';
import Footer from '../components/Footer';

const Home: React.FC = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: '#0a0a1a' }}>
      <Header />
      <Hero />
      <BlockAds />
      <FasterLoading />
      <Privacy />
      <Pricing />
      <Footer />
    </div>
  );
};

export default Home;

